import { render, staticRenderFns } from "./OfficeEmployees.vue?vue&type=template&id=5a1d58a4&"
import script from "./OfficeEmployees.vue?vue&type=script&lang=ts&"
export * from "./OfficeEmployees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports